import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;
export const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
export const AREA_LABEL = { golf: "Golf", gym: "Gym" };
export const fmtDay = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "long" }) : "");

export const switchArea = async (area) => {
  const { data } = await axios.post(`${API}/api/membership/switch`, { origin_url: window.location.origin, area }, auth());
  if (data.checkout_url) window.location.href = data.checkout_url;
  return data;
};

export const buyTopup = async (returnPath) => {
  const { data } = await axios.post(`${API}/api/membership/coach-topup`, { origin_url: window.location.origin, return_path: returnPath }, auth());
  if (data.checkout_url) window.location.href = data.checkout_url;
};

export const switchError = (e) => ({
  premium_voice_member: "You're on My Voice Premium. Message us and we'll set up the right level for you.",
  card_declined: "Your card was declined. Please update it in billing and try again.",
}[e?.response?.data?.detail] || "Something went wrong. Please try again.");
